import React, { useEffect, useState } from "react";
import { Map, Marker } from "@vis.gl/react-google-maps";

// Input: Marker (longitude and latitude)
// Output: Google Map Centered on the given marker
// Error: set to loading if no marker is given
const CustomMap = ({ markerLocation }) => {
  const [map, setMap] = useState(null);

  useEffect(() => {
    if(map) {
      map.panTo(markerLocation);
    }
  }, [map, markerLocation]);

  if (!markerLocation) {
    return <div>Loading map...</div>
  }

  return (
    <div className="map-container">
      <Map
        zoom={13}
        center={markerLocation}
        gestureHandling={"greedy"}
        disableDefaultUI
        onLoad={(mapInstance) => setMap(mapInstance)}
      >
        <Marker position={markerLocation} />
      </Map>
    </div>
  );
};

export default CustomMap;